<template>
  <div class="detail">
    <div class="index" v-if="openClassDetail.show">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1"> {{openClassDetail.info.name}}开课详情 </div>
        <div class="right"></div>
      </div>
      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-input
                v-model="form.name"
                clearable
                placeholder="请输入学生姓名"
              />
            </el-form-item>
            <el-form-item label="">
            <el-select
              v-model="form.state"
              clearable
              placeholder="请选择学生状态"
              class="label"
            >
              <el-option
                v-for="(item, i) in stateList"
                :key="i + 'sh'"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="" style="float: right">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="name"
            label="学生姓名"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column
            align="center"
            prop="school"
            label="校区"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column
            align="center"
            prop="class"
            label="班级"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column
            align="center"
            prop="time"
            label="选课时间"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column
            align="center"
            prop="jion"
            label="报名时间"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column
            align="center"
            prop="onClassTime"
            label="上课时间"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column
            align="center"
            prop="cj"
            label="成绩"
            show-overflow-tooltip
          >
             <template slot-scope="scope">
              <el-button type="text" @click="seeAchievement(scope.row)">{{ scope.row.cj }} </el-button>           
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="state"
            label="状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.state | stateFilter }}
            </template>
          </el-table-column>
        </el-table>
          <el-dialog :title="`${seeObj.name}的${openClassDetail.info.courseName}成绩`" width="300px" :visible.sync="dialogVisible">
            <div class="dialog-content">
                 <table>
                    <tr v-for='(item, index) in achievementData' :key='index'>
                        <td>
                             <span style="margin:20px 20px">{{item.subject}}</span>
                             <span>{{item.fraction}}</span>
                        </td> 
                    </tr>  
                 </table>
            </div>
            <div class="dialog-footer">
              <el-button type="primary" style="margin-top:20px" @click="dialogVisible=false">我知道了</el-button>
            </div>
          </el-dialog>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getAllUserList } from "@/api/user/userCenter";
export default {
  props: ["openClassDetail"],
  components: {},
  data() {
    return {
      form: {
        name: "",
        state:"",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      userId: "",
      tableData: [
        {name:'张三',school:'光谷实验小学',class:'三年级三班',time:'2022-05-11',jion:'2022-5-15',onClassTime:'每周三第五节课',cj:'90',state:'1'}
      ],
      achievementData:[
        {subject:'评分栏目一',fraction:'35'},
        {subject:'评分栏目二',fraction:'78'},
        {subject:'评分栏目三',fraction:'55'},
        {subject:'评分栏目四',fraction:'60'},
      ],
      stateList: [
        { id: "0", label: "指定选课" },
        { id: "1", label: "报名选课" },
        { id: "2", label: "已退课" },
      ],
      dialogVisible:false,
      seeObj:{}
    };
  },
  mounted() {},
  created() {
    this.initData();
  },
  filters: {
    stateFilter(type) {
      const typeMap = {
        0: "指定选课",
        1: "报名选课",
        2: "已退课",
      };
      return typeMap[type];
    },
  },
  methods: {
    async initData() {
    //   let params = {
    //     org_id: sessionStorage.getItem("orgId") || "",
    //     user_type: "", //  （user_type: 0:学生,1:教师,2:家长）不传时查平台所有用户类型
    //     keyword: this.form.name, //	名字模糊搜索
    //     province_code: "", //	省级code
    //     city_code: "", //	市级code
    //     area_code: "", //	区级code
    //     school_period: "", //  教师主教学段（0小学、1初中、2高中详见文档十三.9）
    //     subject_id: "", //	教师主教学科id
    //     page: this.page.pageNum, //  页码
    //     page_size: this.page.pageSize, //  每页条数，默认20，最大50
    //     order_by: "", //  1是按昨日空间访问量排序，0默认按访问量排序
    //     school_id: "", //	学校id，显示老师列表信息
    //     class_id: "", //	班级id，显示学生信息。与school_id两者传其一
    //     vocational_edu: "", //  是否查询职教的学校，1：是
    //     flag: "", //  标记(0:正常,1:演示,2:测试)
    //     platform_code: "", //	实体平台编码
    //     v_platform_code: "", //	虚拟平台编码
    //     badge: "", //	徽章代码，多个逗号分隔
    //     honorary_id: "", //	荣誉id
    //     console_admin_group_source: "", //	按区域管理角色
    //     system_id: "", //	体系id (1:省级培训讲师)
    //     role_id: "", //	角色id (默认角色岗位)
    //     period_type: "", //	学段类型字符串 多个以,连接
    //     status: this.form.status,
    //     org_name: this.form.org_name,
    //     // org_parent_ids: sessionStorage.getItem("orgId")||'', //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
    //   };
    //   var { code, result } = await getAllUserList(params);
    //   if (code == "000000") {
    //     this.tableData = result.list;
    //     this.tableData.forEach((it) => {
    //       it.see = false;
    //     });
    //     console.log("获取书局---", this.tableData);
    //     this.page.totalPage = result.count;
    //   }
    },
    seeAchievement(it){
      this.dialogVisible=true
      this.seeObj=it
    },
    searchFun() {
      this.page.pageNum = 1;
      this.initData();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.initData();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.initData();
    },
    toIndex() {
        this.openClassDetail.show = false;
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    // margin-top: 80px;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .input-list {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;
      p {
        width: 90px;
        line-height: 21px;
        font-size: 14px;
        color: #606266;
      }
    }
  }
  footer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .Homeboxtop_nav_tab {
    span {
      width: 100px;
      font-weight: 400;
      font-size: 15px;
      margin-right: 40px;
      cursor: pointer;
      padding-bottom: 15px;
    }
    .active {
      color: #4991e1;
      border-bottom: 3px solid #4991e1;
    }
  }
  .table {
    width: 100%;
    border: 1px solid #eee;
    .td-1 {
      width: 30%;
      display: inline-block;
      position: relative;
      top: -8px;
    }
    .td-2 {
      width: 70%;
      display: inline-block;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin-right: 20px;
        }
        span {
          width: 200px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 20px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 100%;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
  }
}
::v-deep .el-form .el-input__inner {
  width: 200px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}
</style>
